var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mobile-logo-fms",
    width: 97.978,
    height: 78.23,
    viewBox: "0 0 97.978 78.23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.169,
    y1: 0.686,
    x2: 0.934,
    y2: 0.295,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8880b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd633"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-336 -59.824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.668,21.324c-6,6.722,0,21.512,0,21.512A22.721,22.721,0,0,0,21.344,55.272c13.721,1.092,24.774.756,36.209-8.067s9.529-27.226,9.529-27.226S62.508,3.678,51.454.484,38.877,10.736,26.68,15.946,8.671,14.6,2.668,21.324Z",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 336, 87.157)",
    opacity: 0.61,
    fill: "#FFD633"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 362.572, 84.502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.808,2.4A2.4,2.4,0,1,1,2.4,0,2.4,2.4,0,0,1,4.808,2.4Z",
    transform: "translate(24.746 45.673)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.808,2.4A2.4,2.4,0,1,1,2.4,0,2.4,2.4,0,0,1,4.808,2.4Z",
    transform: "translate(51.929 45.673)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H12.064l8.083,32.187c.569,2.284,3.111,3.915,6.032,3.87H55.494c2.921.045,5.463-1.586,6.032-3.87l4.826-20.168H15.08",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    strokeDasharray: "10 0"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 383.348, 88.751)",
    fontSize: 15,
    fontFamily: "MS-Gothic, MS Gothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MARKET")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 397.688, 110.685)",
    fontSize: 15,
    fontFamily: "MS-Gothic, MS Gothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IN")))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.82fdab54.svg";
export { ForwardRef as ReactComponent };